import { render } from "./CustomerFormModal.vue?vue&type=template&id=d6532638"
import script from "./CustomerFormModal.vue?vue&type=script&lang=js"
export * from "./CustomerFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__